import { Button } from '@nextui-org/react'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

export const NotFoundForm: FC = () => {
  const navigate = useNavigate()

  const onClickLogin = () => {
    navigate('/login')
  }
  const onClickPrev = () => {
    navigate(-1)
  }

  return (
    <div className="w-full max-w-[315px] h-[362px] flex flex-col justify-center -mt-[45px] px-4">
      <div className="w-full flex flex-col items-center">
        <p className="h-[140px] text-[8rem] md:text-[10rem] font-bold text-white align-top">404</p>
        <p className="text-[1.5rem] md:text-[1.875rem] h-fit font-bold p-0 text-white mt-[45px] text-center">
          PAGE NOT FOUND
        </p>
      </div>
      <div className="w-full mt-10">
        <p className="text-[14px] text-white text-center">
          The page you were looking for appears to have been moved, removed or doesn not exist. You
          can go to the pages below.
        </p>
      </div>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
        <Button
          className="text-white font-bold text-[1rem] bg-tdpllightgrey"
          onClick={onClickLogin}
        >
          Login Page
        </Button>
        <Button className="text-white font-bold text-[1rem] bg-tdplplum" onClick={onClickPrev}>
          Previous Page
        </Button>
      </div>
    </div>
  )
}
